import { PackageNameEnum } from '@electricjs/core_entity-client';
import { ISOLVED_PACKAGE_NAMES } from '@/constants/packages';
import { CustomerRedirectParams } from '@/constants/customerRedirects';
import { OrganizationPackageWithEntitlements } from '@/types/packages';
import { useAppSelector } from '@/redux/store';

// ISOLVED_PACKAGE_NAMES is ordered highest tier first, so this picks the best
// plan an org has if it somehow holds more than one Isolved package.
export const findIsolvedPackage = (
  organizationPackages?: OrganizationPackageWithEntitlements[]
): OrganizationPackageWithEntitlements | undefined => {
  for (const name of ISOLVED_PACKAGE_NAMES) {
    const match = organizationPackages?.find(pkg => pkg.package.name === name);
    if (match) return match;
  }
  return undefined;
};

export type CustomerRedirectContext = CustomerRedirectParams & {
  isAtLicenseLimit: boolean;
};

export const useCustomerRedirectParams = (
  organizationId: string,
  organizationPackages?: OrganizationPackageWithEntitlements[]
): CustomerRedirectContext => {
  const hcmIntegrationId = useAppSelector(
    state => state.loggedUser?.organizationHrisIntegration?.id
  );

  const isolvedPackage = findIsolvedPackage(organizationPackages);

  return {
    organizationId,
    hcmIntegrationId,
    currentPlan: isolvedPackage?.package.name as PackageNameEnum | undefined,
    currentSeatCount: isolvedPackage?.licenseCount ?? undefined,
    isAtLicenseLimit: isolvedPackage
      ? (isolvedPackage.availableLicenseCount ?? 0) <= 0
      : false,
  };
};
